import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';

@Component({
  selector: 'app-delete-entry-pop-up',
  templateUrl: './delete-entry-pop-up.component.html',
  styleUrls: ['./delete-entry-pop-up.component.css']
})
export class DeleteEntryPopUpComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<DeleteEntryPopUpComponent>, 
              @Inject(MAT_DIALOG_DATA) public data) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/common/delete-entry-pop-up/delete-entry-pop-up.component.ts